import { useEffect } from 'react';
import { useRequest, useLocalStorageState } from 'ahooks';

// 需要确保在项目初始的入口传入 RbacGateWayInstance
const useRsaKey = ({ getRsaKeyApi }) => {
    const { data, run } = useRequest(getRsaKeyApi, { manual: true });
    const [rsaInfo, setRsaInfo] = useLocalStorageState('rsaInfo');
    useEffect(() => {
        if (rsaInfo) {
            (rsaInfo.time <= Date.now() || !rsaInfo.time) && run();
        }
        else {
            run();
        }
    }, [rsaInfo, run]);
    useEffect(() => {
        const key = data?.data;
        if (key) {
            setRsaInfo({ rsaKey: key, time: Date.now() + 1000 * 60 * 60 * 24 });
        }
    }, [data?.data]);
    return { rsaKey: rsaInfo?.rsaKey };
};

export { useRsaKey };
